<template>
  <v-card>
    <v-parallax
      src="https://chuszoof.files.wordpress.com/2014/11/material_wallpaper_set_two-1.jpg"
    >
      <v-layout column align-center justify-center>
        <h1 class="white--text display-3">Unit Converter</h1>
      </v-layout>
    </v-parallax>
    <v-card-text>
      <v-container>
        <v-layout row wrap>
          <v-flex xs4 v-for="(unit, index) in listUnit" :key="index">
            <v-card :color="unit.color" class="white--text mr-2 mb-2">
              <v-card-title primary-title>
                <div class="headline">{{ unit.name }}</div>
              </v-card-title>
              <v-card-actions>
                <v-btn flat dark @click.native="$router.push(unit.href)"
                  >Convert now</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      listUnit: [
        {
          name: 'Length',
          color: 'red accent-2',
          href: '/length'
        },
        {
          name: 'Temperature',
          color: 'pink accent-2',
          href: '/temperature'
        },
        {
          name: 'Volume',
          color: 'purple accent-2',
          href: '/volume'
        },
        {
          name: 'Weight',
          color: 'deep-purple accent-2',
          href: '/weight'
        },
        {
          name: 'Time',
          color: 'indigo accent-3',
          href: '/time'
        },
        {
          name: 'Acceleration',
          color: 'light-blue darken-2',
          href: '/acceleration'
        },
        {
          name: 'Amount of Substance',
          color: 'blue darken-2',
          href: '/amount-of-substance'
        },
        {
          name: 'Angle',
          color: 'indigo darken-2',
          href: '/angle'
        },
        {
          name: 'Area',
          color: 'teal darken-2',
          href: '/area'
        },
        {
          name: 'Astronomical',
          color: 'green darken-2',
          href: '/astronomical'
        },
        {
          name: 'Blood Sugar',
          color: 'light-green darken-2',
          href: '/blood-sugar'
        },
        {
          name: 'Capacitance',
          color: 'lime darken-2',
          href: '/capacitance'
        },
        {
          name: 'Computer Storage',
          color: 'yellow darken-2',
          href: '/computer'
        },
        {
          name: 'Cooking',
          color: 'amber darken-2',
          href: '/cooking'
        },
        {
          name: 'Data Transfer',
          color: 'orange darken-2',
          href: '/data-transfer'
        },
        {
          name: 'Density',
          color: 'deep-orange darken-2',
          href: '/density'
        },
        {
          name: 'Dynamic Viscosity',
          color: 'brown darken-2',
          href: '/dynamic-viscosity'
        },
        {
          name: 'Electric Charge',
          color: 'blue-grey darken-2',
          href: '/electric-charge'
        },
        {
          name: 'Electrical Resistance',
          color: 'grey darken-2',
          href: '/electrical-resistance'
        },
        {
          name: 'Energy and Work',
          color: 'red darken-2',
          href: '/energy'
        },
        {
          name: 'Force',
          color: 'pink darken-2',
          href: '/force'
        },
        {
          name: 'Illuminance',
          color: 'purple darken-2',
          href: '/illuminance'
        },
        {
          name: 'Inductance',
          color: 'deep-purple darken-2',
          href: '/inductance'
        }
      ]
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?6a042f6b